<template>
  <div class="upload-image">
    <Spin v-show="loading" fix>
      <Icon type="ios-loading" size="30" class="c-fix-loading" />
      <span>上传中</span>
    </Spin>
    <div class="c-wrap">
      <div v-if="image" class="c-complete">
        <Upload action="" :before-upload="preUpload">
          <el-image class="m-image-box" :src="image" fit="scale-down"></el-image>
        </Upload>
      </div>
      <Upload v-else class="c-init" action="" :before-upload="preUpload">
        <div class="min-column">
          <Icon type="md-add" size="20" />
          <span>{{ upTxt }}</span>
          <span v-if="rules" class="m-image-rule">{{ rules }}</span>
        </div>
      </Upload>
    </div>
    <div class="c-message" v-show="!disabledInfo">
      <Icon type="ios-alert-outline" :size="16" />
      <span class="c-info">格式支持 {{ fileTypeStr }}</span>
    </div>
    <div class="c-col-msg" v-if="msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import { isEmpty } from '@/common/js/utils'
import { uploadImage } from '@/api/landpage.model'
export default {
  name: 'upload',
  props: {
    value: {
      type: [String, Number]
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    size: {
      type: Number,
      default() {
        return 1024
      }
    },
    format: {
      type: Array,
      default() {
        return ['jpeg', 'png']
      }
    },
    verify: {
      type: Boolean
    },
    upTxt: {
      type: String,
      default: '上传图片'
    },
    rules: {
      type: String
    },
    disabledInfo: {
      type: Boolean
    }
  },
  computed: {
    image: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    fileType() {
      return this.format.map((ret) => {
        const mimetype = ret && typeof ret === 'string' && ret.toLowerCase()
        return `image/${mimetype}`
      })
    },
    fileTypeStr() {
      return this.format.map((ret) => ret.toUpperCase()).join(' | ')
    },
    msg() {
      return this.verify && isEmpty(this.image) ? '上传图片不能为空' : ''
    }
  },
  methods: {
    preUpload(file) {
      const { size, name, type } = file
      if (!this.fileType.includes(type)) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: `上传的文件名 ${name} 格式错误！`
        })
        return false
      }
      if (size > this.size * 1024) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: `上传的文件名 ${name} 超过限制大小`
        })
        return false
      }
      this.uploadFile(file)
      return false
    },
    uploadFile(file) {
      this.loading = true
      uploadImage({ file }).then((data) => {
        this.loading = false
        if (data && data.url && data.width && data.height) {
          const { url, width, height } = data
          if (this.rules && typeof this.rules === 'string' && this.rules.includes('x')) {
            const [rule_w] = this.rules.replace(/建议:/g, '').split('x')
            if (width < Number(rule_w)) {
              this.$Message.error('图片不符合尺寸的最小规格')
              return
            }
          }
          this.$emit('input', url)
          this.$emit('on-change', { width, height })
        }
      })
    }
  },
  data() {
    return {
      loading: null
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-image {
  width: inherit;
  max-width: 340px;
  min-width: 100px;
  overflow: hidden;

  .c-wrap {
    width: 100%;
    max-width: 340px;

    ::v-deep .ivu-upload,
    .c-complete {
      position: relative;
      z-index: 2;
    }

    .c-complete {
      width: 100px;
      height: 100px;
      background-color: #efefef;

      img {
        border-radius: 4px;
      }

      .m-image-box {
        width: 100px;
        height: 100px;
      }
    }

    .c-init {
      width: 100px;
      height: 100px;
      border-style: dashed;
      border-width: 1px;
      border-color: #4b77ee;
      border-radius: 4px;
      text-align: center;

      i,
      span {
        color: #4b77ee;
      }

      .min-column {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        width: 90px;
        height: 100%;
        margin: 0 auto;

        .m-image-rule {
          color: #8d8d8d;
          font-size: 12px;
          line-height: 1;
        }
      }
    }

    ::v-deep .ivu-upload-select {
      width: 100%;
      height: 100%;
      cursor: pointer;
      user-select: none;
    }
  }

  .c-message {
    line-height: 30px;

    i {
      display: inline-block;
    }

    .c-info {
      margin-left: 5px;
    }
  }
}

.c-col-msg {
  position: absolute;
  z-index: 997;
  left: 0;
  bottom: -16px;
  color: #ff4400;
}

.c-fix-loading {
  animation: ani-demo-spin 1s linear infinite;
}
</style>
